class CookieUtil {
    // 设置 cookie
    static set(name, value, hours) {
        try {
            let expires = "";
            if (hours) {
                const date = new Date();
                date.setTime(date.getTime() + (hours * 60 * 60 * 1000)); // 转换为毫秒
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + (value || "") + expires + "; path=/";
            return true; // 成功设置返回 true
        } catch (error) {
            console.error("设置 cookie 失败:", error);
            return false; // 设置失败返回 false
        }
    }

    // 获取 cookie
    static get(name) {
        try {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
            return null; // 如果未找到 cookie，返回 null
        } catch (error) {
            console.error("获取 cookie 失败:", error);
            return null; // 获取失败返回 null
        }
    }

    // 删除 cookie
    static delete(name) {
        try {
            document.cookie = name + '=; Max-Age=-99999999; path=/';
            return true; // 成功删除返回 true
        } catch (error) {
            console.error("删除 cookie 失败:", error);
            return false; // 删除失败返回 false
        }
    }
}

export default CookieUtil;